import React, { Component } from 'react';
import PropTypes from 'prop-types';
import GeckoRequest from 'services/gecko-request';
import { renderError } from 'services/gecko-error';
import { GECKO_CONSTS, GECKO_UTILS, GeckoFields } from 'ui';
import AsyncSelect from 'components/AsyncSelect';
import ReplyBoxField from 'components/ReplyBoxField';
import Loader from 'components/Loader';
import {
  buildContactGroup,
  buildSelectedChannelGroup,
} from 'services/template-tags';
import { BotTagManagerField } from '../BotTagManager';

import './index.scss';

class FormFields extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editting: {},
    };
  }

  templateContext() {
    return [
      {
        label: 'Form value',
        tag: 'form',
        type: 'group',
        value: this.props.value.map((field) => {
          let type = 'text';
          let value = `Example ${field.label}`;
          if (field.type === 'date') {
            type = 'date_time';
            value = new Date();
          }
          if (field.type === 'multi') {
            type = 'list';
            value = [
              'Example selection 1',
              'Example selection 2',
              'Example selection 3',
            ];
          }
          if (field.type === 'textarea') {
            type = 'multiline_text';
          }
          return {
            label: field.label,
            tag: field.id,
            value,
            type,
          };
        }),
      },
      buildContactGroup(),
      buildSelectedChannelGroup({
        channel: null,
        showChannelQueuePosition: true,
      }),
    ];
  }

  render() {
    return (
      <div className="SkillGeckoForm-FormFields">
        {this.props.value
          .sort((f1, f2) => f1.order - f2.order)
          .map((field) => {
            const isEditting = this.state.editting[field.id];
            const toggleEditting = () => {
              const editting = Object.assign({}, this.state.editting, {
                [field.id]: !isEditting,
              });
              this.setState({ editting });
            };
            const changeHandler = (question) => {
              const newField = Object.assign({}, field, { question });
              const newFields = this.props.value.map((oldField) => {
                if (oldField.id !== field.id) {
                  return oldField;
                }
                return newField;
              });
              this.props.onChange(newFields);
            };
            const iconClassMap = {
              name: 'fal fa-user',
              email: 'fal fa-at',
              tel: 'fal fa-phone',
              text: 'fal fa-align-left',
              textarea: 'fal fa-align-left',
              date: 'fal fa-calendar-alt',
              event: 'fal fa-calendar-alt',
              address: 'fal fa-home',
            };
            return (
              <div key={field.id} className="SkillGeckoForm-FormFields-field">
                <div
                  className="SkillGeckoForm-FormFields-field-display"
                  onClick={toggleEditting}
                >
                  <div className="SkillGeckoForm-FormFields-field-typeicon">
                    <i
                      className={iconClassMap[field.type] || 'fal fa-info'}
                    ></i>
                  </div>
                  <div className="SkillGeckoForm-FormFields-field-label">
                    {field.label}
                  </div>
                  {isEditting ? (
                    <div className="SkillGeckoForm-FormFields-field-closeicon">
                      <i className="far fa-angle-up"></i>
                    </div>
                  ) : (
                    <div className="SkillGeckoForm-FormFields-field-editicon">
                      <i className="fal fa-edit"></i>
                    </div>
                  )}
                </div>
                {isEditting ? (
                  <div className="SkillGeckoForm-FormFields-field-edit">
                    <ReplyBoxField
                      value={field.question}
                      onChange={changeHandler}
                      templateContext={this.templateContext()}
                      compileTemplateTags={false}
                      meta={{ mail_merge: { show: true } }}
                    />
                  </div>
                ) : null}
              </div>
            );
          })}
      </div>
    );
  }
}

class SkillGeckoForm extends Component {
  static propTypes = {
    value: PropTypes.shape({
      name: PropTypes.string,
      internal_skill: 'GECKO_FORM',
      config: PropTypes.shape({
        confirm_message: PropTypes.string,
        exit_message: PropTypes.string,
        fields: PropTypes.arrayOf(PropTypes.object),
      }),
    }),
    onChange: PropTypes.func,
  };
  static defaultProps = {
    value: {
      name: null,
      internal_skill: 'GECKO_FORM',
      config: {
        confirm_message: `I'll just need to grab a few details from you in order to progress.  During this time you won't be able to ask me anything else, do you want to continue?`,
        exit_message: `Great!  Thanks for providing me with those.`,
        fields: [],
      },
    },
    onChange: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      loadingFields: false,
    };
  }

  templateContext = [
    buildContactGroup(),
    buildSelectedChannelGroup({
      channel: null,
      showChannelQueuePosition: true,
    }),
  ];

  componentDidUpdate(prevProps) {
    if (this.props.value.config.form_id !== prevProps.value.config.form_id) {
      this.setState({ loadingFields: true });
      GeckoRequest.get(`/engage/form/${this.props.value.config.form_id}/fields`)
        .then((fields) => {
          return fields.map((field) => {
            const existingField = this.props.value.config.fields.find(
              (existingField) => field.id === existingField.id
            );
            if (existingField) {
              return Object.assign({}, field, {
                question: existingField.question,
              });
            }
            return Object.assign({}, field, {
              question: `What is your ${field.label}?`,
            });
          });
        })
        .then((fields) => {
          const supportedFieldTypes = [
            'name',
            'email',
            'tel',
            'text',
            'textarea',
            'select',
            'multi',
            'checkbox',
            'radio',
            'address',
            'number',
            'date',
            'event',
          ];
          const [supportedFields, unsupportedFields] = fields.reduce(
            ([supportedFields, unsupportedFields], field) => {
              if (supportedFieldTypes.includes(field.type)) {
                return [supportedFields.concat(field), unsupportedFields];
              }
              return [supportedFields, unsupportedFields.concat(field)];
            },
            [[], []]
          );
          return [supportedFields, unsupportedFields];
        })
        .then(([supportedFields, unsupportedFields]) => {
          const config = Object.assign({}, this.props.value.config, {
            fields: supportedFields,
          });
          const skill = Object.assign({}, this.props.value, { config });
          this.props.onChange(skill);
          this.setState({ unsupportedFields, loadingFields: false });
        })
        .catch((err) => {
          renderError(err);
          this.setState({ loadingFields: false });
        });
    }
  }

  fieldsTemplateContext() {
    if (
      !this.props.value.config.fields ||
      !this.props.value.config.fields.length
    ) {
      return this.templateContext;
    }
    return [
      {
        label: 'Form value',
        tag: 'form',
        type: 'group',
        value: this.props.value.config.fields.map((field) => {
          let type = 'text';
          let value = `Example ${field.label}`;
          if (field.type === 'date') {
            type = 'date_time';
            value = new Date();
          }
          if (field.type === 'multi' || field.type === 'checkbox') {
            type = 'list';
            value = [
              'Example selection 1',
              'Example selection 2',
              'Example selection 3',
            ];
          }
          if (field.type === 'textarea') {
            type = 'multiline_text';
          }
          if (field.type === 'address') {
            type = 'multiline_text';
            value = `Address Line 1\nAddress Line 2\nCity\nState\nPostal Code\nCountry`;
          }
          return {
            label: field.label,
            tag: field.id,
            value,
            type,
          };
        }),
      },
    ].concat(this.templateContext);
  }

  fields() {
    return [
      {
        key: '',
        label: 'Configure the Gecko Form Skill',
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        width: '100%',
        className: 'BotTabEditContainer-section-heading',
        component: <div style={{ display: 'none' }}></div>,
      },
      {
        key: 'name',
        label: 'Skill Title',
        required: true,
        width: '100%',
        type: GECKO_CONSTS.FIELD_TYPE_TEXT,
      },
      {
        key: 'bot_tag_ids',
        label: 'Skill Tags',
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        width: '100%',
        component: <BotTagManagerField item={this.props.value} />,
      },
      {
        key: 'config.form_id',
        label: 'Choose a Gecko form',
        required: true,
        width: '100%',
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        component: (
          <AsyncSelect
            getUrl={`/engage/forms`}
            selectUrl={`/engage/forms`}
            optionTransform={(form) => ({
              label: form.internal_name || form.name,
              value: form.id,
            })}
          />
        ),
      },
      {
        key: 'config.confirm_message',
        label: 'Confirm message',
        required: true,
        width: '100%',
        description:
          'A confirmation message that will allow the user to confrm they want to continue.  They will get the options for Yes and No.',
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        component: (
          <ReplyBoxField
            templateContext={this.templateContext}
            compileTemplateTags={false}
            meta={{ mail_merge: { show: true } }}
          />
        ),
      },
      {
        key: 'config.exit_message',
        label: 'Exit message',
        required: true,
        width: '100%',
        description: 'A message to wrap up the skill and let the user know.',
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        component: (
          <ReplyBoxField
            templateContext={this.fieldsTemplateContext()}
            compileTemplateTags={false}
            meta={{ mail_merge: { show: true } }}
          />
        ),
      },
      {
        key: 'config.fields',
        label: 'Configure fields',
        width: '100%',
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        hideWhen: () => !this.props.value || !this.props.value.config.form_id,
        component: this.state.loadingFields ? (
          <Loader isLoading={true} />
        ) : (
          <FormFields />
        ),
      },
      {
        key: '_',
        label: 'Unsupported fields',
        width: '100%',
        description:
          'These fields on your form are currently not supported by the Bot and will be skipped',
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        hideWhen: () =>
          !this.props.value ||
          !this.props.value.config.form_id ||
          !this.state.unsupportedFields ||
          !this.state.unsupportedFields.length,
        component: (
          <div className="SkillGeckoForm-unsupported-fields">
            {this.state.unsupportedFields &&
              this.state.unsupportedFields.length &&
              this.state.unsupportedFields.map((field, index) => {
                return (
                  <span key={field.id}>
                    {`${index === 0 ? '' : ', '}`}
                    {field.label}
                  </span>
                );
              })}
          </div>
        ),
      },
    ];
  }

  handler(key, value) {
    const skill = GECKO_UTILS.setNestedValue(this.props.value, key, value);
    this.props.onChange(skill);
  }

  render() {
    return (
      <div className="SkillGeckoForm">
        <div className="row">
          <GeckoFields
            values={this.props.value}
            fields={this.fields()}
            handler={this.handler.bind(this)}
          />
        </div>
      </div>
    );
  }
}

export default SkillGeckoForm;
